<template>
  <div class="d-flex flex-column h-100">
    <BModal
      v-model="catalogForm"
      hide-footer
      hide-header
      size="lg"
    >
      <CatalogForm
        :show-old-catering="!haveOldCatering"
        @close="catalogForm = false"
        @open="openCatalog"
        @refresh="request"
      />
    </BModal>

    <div class="d-flex justify-content-between">
      <div class="page-title-wrapper">
        <div class="page-title active">
          {{ $t('shop.catalog.catalogs') }}
        </div>
      </div>
      <div class="d-flex align-items-center">
        <button
          v-if="payeeAdmin"
          class="btn btn-sm btn-primary"
          @click="catalogForm = true"
        >
          <i class="fas fa-plus mr-1" />
          {{ $t('shop.catalog.add') }}
        </button>
        <div
          v-if="anyCatalogAdmin"
          v-tippy
          :content="$t('shop.catalog.archived')"
          class="light-button ml-2"
          @click="showArchived"
        >
          <i class="far fa-box-archive" />
        </div>
      </div>
    </div>
    <Loader v-if="pending" />
    <div class="flex-grow-1 catalogs-scroll">
      <CatalogRow
        v-for="c in catalogs"
        :key="c.id"
        :catalog="c"
        class="mb-2"
        @edit="openCatalog(c.id)"
      />
    </div>
  </div>
</template>

<script>
import { mapActions, mapGetters } from 'vuex';
import CatalogForm from './CatalogForm';
import CatalogRow from './CatalogRow';

export default {
  data: () => ({
    editedId: null,
    catalogForm: false,
    pending: false,
  }),
  components: {
    CatalogRow,
    CatalogForm,
  },
  computed: {
    ...mapGetters(['payeeId', 'payeeAdmin', 'anyCatalogAdmin']),
    ...mapGetters('shop', ['catalogs']),
    haveOldCatering() {
      return this.catalogs.some((c) => c.id === '00000000-0000-0000-0000-000000000000');
    },
  },
  methods: {
    ...mapActions('shop', ['getShopCatalogs']),
    showArchived() {
      this.$router.push(`/payee/${this.payeeId}/shop/catalogs/archived`);
    },
    openCatalog(id) {
      this.$router.push(`/payee/${this.payeeId}/shop/${id}/orders`);
    },
    request() {
      this.pending = true;
      this.getShopCatalogs()
        .finally(() => {
          this.pending = false;
        });
    },
  },
  created() {
    this.$emit('page', 'catalogs');
    this.request();
  },
};
</script>

<style lang="scss" scoped>
.catalogs-scroll {
  min-height: 0;
  overflow-y: auto;
  padding-bottom: 16px;
}
</style>
